import React from 'react';

import { IconButton, Tooltip } from '@mui/material';
import { Trash } from 'iconsax-react';

import { useSelector, useTranslation } from 'third-party';

import { EMPTY_EMAIL_MESSAGE, useSettings } from 'modules/setting';

import { settingSelectors } from 'selectors';

export const RevertTemplate = () => {
  const { resetEmailTemplate } = useSettings();
  const { t } = useTranslation();
  const loadEmailTemplatePending = useSelector(
    settingSelectors.loadEmailTemplatePending,
  );
  const saveSettingPending = useSelector(settingSelectors.saveSettingPending);

  const disabledClear = saveSettingPending || loadEmailTemplatePending;

  const handleRevert = () => {
    resetEmailTemplate(EMPTY_EMAIL_MESSAGE);
  };

  return (
    <Tooltip title={t('emailDesigner.actions.clearTemplate')}>
      <IconButton disabled={disabledClear} onClick={() => handleRevert()}>
        <Trash variant="TwoTone" size="20" />
      </IconButton>
    </Tooltip>
  );
};
